export default "__VITE_ASSET__B_Xb19K3__"